'use client';

import { Card, Label } from '@repo/ui';
import { ScrollableContainer } from '../common/scrollable-container';
import { DistributionGraph } from '../common/distribution-graph';
import { MedianResult } from '../../../lib/stats/median';

interface MedianCalculatorProps {
  visualizationData: MedianResult | null;
}

export function MedianCalculator({ visualizationData: result }: MedianCalculatorProps) {
  if (!result) {
    return null;
  }

  return (
    <ScrollableContainer>
      <div className="space-y-6">
        <Card className="p-4">
          <h3 className="text-lg font-semibold mb-4">Median Results</h3>
          <div className="space-y-4">
            <div>
              <Label>Median Value</Label>
              <div className="text-lg font-semibold">{result.median.toFixed(4)}</div>
            </div>
            <div>
              <Label>Interpretation</Label>
              <div className="text-sm text-muted-foreground">{result.interpretation}</div>
            </div>
          </div>
        </Card>

        <Card className="p-4">
          <h3 className="text-lg font-semibold mb-4">Distribution Plot</h3>
          <DistributionGraph
            data={result.data}
            height={300}
            showMedian
            grid={{
              left: '10%',
              right: '5%',
              top: '10%',
              bottom: '10%'
            }}
          />
        </Card>
      </div>
    </ScrollableContainer>
  );
} 